import env from '@common/constants/env';

const { VITE_ENV } = env;
const sentryReplayEnabledEnvironments = ['production', 'productioneu'];
export const isSentryReplayEnabled = sentryReplayEnabledEnvironments.includes(VITE_ENV);
